// 1. GRÁFICO GÊNERO
const genero = document.getElementById("grafico__genero");
if (genero) {
	new Chart(genero, {
		type: "doughnut",
		plugins: [ChartDataLabels],
		data: {
			labels: ["Feminino", "Masculino"],
			datasets: [
				{
					data: [30, 70],
					backgroundColor: ["#aecc53", "#dce168"],
					hoverBackgroundColor: ["#aecc53", "#dce168"],
					borderWidth: 0,
					cutout: "55%",
				},
			],
		},
		options: {
			plugins: {
				datalabels: {
					labels: {
						value: {
							font: {
								family: "'proxima-nova', sans-serif",
								size: 18,
								weight: "bold",
							},
							color: "black",
						},
					},
					formatter: function (value, context) {
						return value + "%";
					},
				},
				legend: {
					onClick: () => {},
					position: "bottom",
					labels: {
						padding: 15,
						usePointStyle: true,
						pointStyle: "circle",
						font: {
							size: 16,
							family: "'proxima-nova', sans-serif",
						},
					},
				},
				tooltip: {
					enabled: false,
				},
			},
		},
	});
}
